import { Check } from 'lucide-react'

export type PasswordStrength = { score: 0 | 1 | 2 | 3; label: string; color: string }

export function getPasswordStrength(password: string): PasswordStrength {
  if (password.length === 0) return { score: 0, label: '', color: '' }
  let score = 0
  if (password.length >= 12) score++
  if (/[A-Z]/.test(password)) score++
  if (/[0-9]/.test(password)) score++
  const levels = [
    { score: 0, label: '', color: '' },
    { score: 1, label: 'Debole', color: 'bg-red-500' },
    { score: 2, label: 'Discreta', color: 'bg-amber-400' },
    { score: 3, label: 'Sicura', color: 'bg-green-500' },
  ] as const
  return levels[score as 0 | 1 | 2 | 3]
}

export function isPasswordValid(password: string): boolean {
  return password.length >= 12 && /[A-Z]/.test(password) && /[0-9]/.test(password)
}

const rules = [
  { label: 'Almeno 12 caratteri', test: (p: string) => p.length >= 12 },
  { label: 'Almeno una lettera maiuscola', test: (p: string) => /[A-Z]/.test(p) },
  { label: 'Almeno un numero', test: (p: string) => /[0-9]/.test(p) },
]

export default function PasswordStrengthBar({ password }: { password: string }) {
  const { score, label, color } = getPasswordStrength(password)
  if (password.length === 0) return null

  return (
    <div className="mt-1 flex flex-col gap-2">
      <div className="flex gap-1">
        {[1, 2, 3].map(i => (
          <div
            key={i}
            className={`h-1 flex-1 rounded-full transition-colors ${score >= i ? color : 'bg-gray-200'}`}
          />
        ))}
      </div>
      <p className={`text-xs font-medium ${score === 1 ? 'text-red-500' : score === 2 ? 'text-amber-500' : 'text-green-600'}`}>
        {label}
      </p>
      <ul className="flex flex-col gap-0.5">
        {rules.map(({ label, test }) => {
          const ok = test(password)
          return (
            <li key={label} className={`flex items-center gap-1.5 text-xs ${ok ? 'text-green-600' : 'text-gray-400'}`}>
              <Check size={11} className={ok ? 'opacity-100' : 'opacity-30'} />
              {label}
            </li>
          )
        })}
      </ul>
    </div>
  )
}
